import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=14cf7c22&"
import script from "./Contato.vue?vue&type=script&lang=js&"
export * from "./Contato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports